import { render, staticRenderFns } from "./PayProjects.vue?vue&type=template&id=1c8cc802&scoped=true"
import script from "./PayProjects.vue?vue&type=script&lang=js"
export * from "./PayProjects.vue?vue&type=script&lang=js"
import style0 from "./PayProjects.vue?vue&type=style&index=0&id=1c8cc802&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8cc802",
  null
  
)

export default component.exports